import { useState } from 'react'
import { supabase } from './supabase'
import { LiensLegaux } from './actions'

const CORAL = '#E8522A'
const CHARBON = '#1C1C1C'

export default function Auth() {
  const [mode, setMode] = useState('login') // 'login' | 'register'
  const [email, setEmail] = useState('')
  const [password, setPassword] = useState('')
  const [nomCommerce, setNomCommerce] = useState('')
  const [typeCommerce, setTypeCommerce] = useState('')
  const [telephone, setTelephone] = useState('')
  const [loading, setLoading] = useState(false)
  const [error, setError] = useState('')
  const [success, setSuccess] = useState('')

  async function handleLogin(e) {
    e.preventDefault()
    setLoading(true)
    setError('')
    const { error } = await supabase.auth.signInWithPassword({ email, password })
    if (error) setError('Email ou mot de passe incorrect')
    setLoading(false)
  }

  async function handleRegister(e) {
    e.preventDefault()
    setLoading(true)
    setError('')
    if (!nomCommerce || !email || !password) {
      setError('Remplis tous les champs obligatoires')
      setLoading(false)
      return
    }

    const { data, error } = await supabase.auth.signUp({
      email,
      password,
      options: {
        data: {
          nom_commerce: nomCommerce,
          type_commerce: typeCommerce,
          telephone,
        },
      },
    })
    if (error) {
      setError(error.message)
      setLoading(false)
      return
    }

    if (data.user) {
      // Tente l'insertion immédiate (fonctionne si pas de email confirmation).
      // Si RLS bloque (user pas encore authentifié), fetchCommerce re-tentera au login.
      const { error: insErr } = await supabase.from('commerces').insert({
        id: data.user.id,
        nom: nomCommerce,
        type: typeCommerce,
        email,
        telephone,
      })
      if (insErr) console.warn('Insert commerce différé au login:', insErr.message)
      setSuccess('Compte créé ! Ouverture de ton tableau de bord…')
    }
    setLoading(false)
  }

  return (
    <div style={{ minHeight: '100vh', background: '#f5f0eb', display: 'flex', alignItems: 'center', justifyContent: 'center', fontFamily: '-apple-system, BlinkMacSystemFont, sans-serif' }}>
      <div style={{ width: '100%', maxWidth: 420, padding: '0 1rem' }}>

        {/* Logo */}
        <div style={{ display: 'flex', alignItems: 'center', gap: 12, justifyContent: 'center', marginBottom: '2.5rem' }}>
          <div style={{ width: 44, height: 44, background: CORAL, borderRadius: 12, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
            <svg width="26" height="26" viewBox="0 0 100 100" fill="none">
              <rect x="10" y="14" width="44" height="26" rx="5" fill="#fff" opacity="0.5" transform="rotate(-5 32 27)"/>
              <rect x="14" y="8" width="44" height="26" rx="5" fill="#fff" opacity="0.9" transform="rotate(3 36 21)"/>
              <rect x="8" y="44" width="72" height="48" rx="10" fill="#fff" opacity="0.95"/>
              <circle cx="79" cy="67" r="5.5" fill={CORAL}/>
              <circle cx="79" cy="67" r="2.5" fill="#fff"/>
            </svg>
          </div>
          <span style={{ fontSize: 28, fontWeight: 800, letterSpacing: -1.5, color: CHARBON }}>jeebi</span>
        </div>

        {/* Card */}
        <div style={{ background: '#fff', borderRadius: 16, padding: '2rem', border: '1px solid #e8e0d8' }}>
          
          {/* Tabs */}
          <div style={{ display: 'flex', gap: 0, marginBottom: '1.5rem', background: '#f5f0eb', borderRadius: 10, padding: 4 }}>
            {['login', 'register'].map(m => (
              <button
                key={m}
                onClick={() => { setMode(m); setError(''); setSuccess('') }}
                style={{ flex: 1, padding: '8px', border: 'none', borderRadius: 8, cursor: 'pointer', fontWeight: 600, fontSize: 14, background: mode === m ? '#fff' : 'transparent', color: mode === m ? CHARBON : '#999', transition: 'all 0.15s' }}
              >
                {m === 'login' ? 'Connexion' : 'Inscription'}
              </button>
            ))}
          </div>

          {/* Login Form */}
          {mode === 'login' && (
            <form onSubmit={handleLogin}>
              <div style={{ marginBottom: 12 }}>
                <label style={{ fontSize: 13, color: '#666', display: 'block', marginBottom: 6 }}>Email</label>
                <input
                  type="email"
                  value={email}
                  onChange={e => setEmail(e.target.value)}
                  placeholder="contact@moncommerce.fr"
                  style={{ width: '100%', padding: '10px 12px', borderRadius: 8, border: '1px solid #e8e0d8', fontSize: 14, boxSizing: 'border-box' }}
                />
              </div>
              <div style={{ marginBottom: 20 }}>
                <label style={{ fontSize: 13, color: '#666', display: 'block', marginBottom: 6 }}>Mot de passe</label>
                <input
                  type="password"
                  value={password}
                  onChange={e => setPassword(e.target.value)}
                  placeholder="••••••••"
                  style={{ width: '100%', padding: '10px 12px', borderRadius: 8, border: '1px solid #e8e0d8', fontSize: 14, boxSizing: 'border-box' }}
                />
              </div>
              {error && <div style={{ color: '#E24B4A', fontSize: 13, marginBottom: 12 }}>{error}</div>}
              <button
                type="submit"
                disabled={loading}
                style={{ width: '100%', background: CORAL, color: '#fff', border: 'none', borderRadius: 10, padding: '12px', fontSize: 15, fontWeight: 700, cursor: 'pointer', opacity: loading ? 0.7 : 1 }}
              >
                {loading ? 'Connexion...' : 'Se connecter'}
              </button>
            </form>
          )}

          {/* Register Form */}
          {mode === 'register' && (
            <form onSubmit={handleRegister}>
              <div style={{ marginBottom: 12 }}>
                <label style={{ fontSize: 13, color: '#666', display: 'block', marginBottom: 6 }}>Nom du commerce *</label>
                <input
                  value={nomCommerce}
                  onChange={e => setNomCommerce(e.target.value)}
                  placeholder="Barber Shop Karim"
                  style={{ width: '100%', padding: '10px 12px', borderRadius: 8, border: '1px solid #e8e0d8', fontSize: 14, boxSizing: 'border-box' }}
                />
              </div>
              <div style={{ marginBottom: 12 }}>
                <label style={{ fontSize: 13, color: '#666', display: 'block', marginBottom: 6 }}>Type de commerce</label>
                <select
                  value={typeCommerce}
                  onChange={e => setTypeCommerce(e.target.value)}
                  style={{ width: '100%', padding: '10px 12px', borderRadius: 8, border: '1px solid #e8e0d8', fontSize: 14, boxSizing: 'border-box', background: '#fff' }}
                >
                  <option value="">Sélectionner...</option>
                  <option value="barbier">Barbier</option>
                  <option value="restaurant">Restaurant / Kebab</option>
                  <option value="cafe">Café</option>
                  <option value="epicerie">Épicerie</option>
                  <option value="autre">Autre</option>
                </select>
              </div>
              <div style={{ marginBottom: 12 }}>
                <label style={{ fontSize: 13, color: '#666', display: 'block', marginBottom: 6 }}>Téléphone</label>
                <input
                  value={telephone}
                  onChange={e => setTelephone(e.target.value)}
                  placeholder="06 00 00 00 00"
                  style={{ width: '100%', padding: '10px 12px', borderRadius: 8, border: '1px solid #e8e0d8', fontSize: 14, boxSizing: 'border-box' }}
                />
              </div>
              <div style={{ marginBottom: 12 }}>
                <label style={{ fontSize: 13, color: '#666', display: 'block', marginBottom: 6 }}>Email *</label>
                <input
                  type="email"
                  value={email}
                  onChange={e => setEmail(e.target.value)}
                  placeholder="contact@moncommerce.fr"
                  style={{ width: '100%', padding: '10px 12px', borderRadius: 8, border: '1px solid #e8e0d8', fontSize: 14, boxSizing: 'border-box' }}
                />
              </div>
              <div style={{ marginBottom: 20 }}>
                <label style={{ fontSize: 13, color: '#666', display: 'block', marginBottom: 6 }}>Mot de passe *</label>
                <input
                  type="password"
                  value={password}
                  onChange={e => setPassword(e.target.value)}
                  placeholder="••••••••"
                  style={{ width: '100%', padding: '10px 12px', borderRadius: 8, border: '1px solid #e8e0d8', fontSize: 14, boxSizing: 'border-box' }}
                />
              </div>
              {error && <div style={{ color: '#E24B4A', fontSize: 13, marginBottom: 12 }}>{error}</div>}
              {success && <div style={{ color: '#3B6D11', fontSize: 13, marginBottom: 12 }}>{success}</div>}
              <button
                type="submit"
                disabled={loading}
                style={{ width: '100%', background: CORAL, color: '#fff', border: 'none', borderRadius: 10, padding: '12px', fontSize: 15, fontWeight: 700, cursor: 'pointer', opacity: loading ? 0.7 : 1 }}
              >
                {loading ? 'Création...' : 'Créer mon compte'}
              </button>
              <div style={{ fontSize: 11, color: '#aaa', marginTop: 10, textAlign: 'center', lineHeight: 1.5 }}>
                En créant un compte, tu acceptes les <a href="/legal/cgv" style={{ color: '#888' }}>conditions générales</a> et
                l'<a href="/legal/dpa" style={{ color: '#888' }}>accord de traitement des données</a>.
              </div>
            </form>
          )}
        </div>

        <div style={{ textAlign: 'center', marginTop: '1.5rem', fontSize: 12, color: '#bbb' }}>
          Jeebi — Cartes de fidélité digitales
        </div>
        <LiensLegaux style={{ marginTop: 8 }} />
      </div>
    </div>
  )
}
